module.exports = __webpack_public_path__ + "media/abk/assets/images/404-294250b64c6c2c5cd41973cb3ff50255.png";